import React, { useContext } from 'react';
import { useRedeemEmailConfirmationToken } from '../hooks/useRedeemEmailConfirmationToken';

import { useSearchParams } from 'react-router-dom';
import { RequestStatus } from '../util/app.types';
import { Tr8Context } from '../App';

export const RedeemEmailConfirmation = (): JSX.Element => {
  const tr8 = useContext(Tr8Context);
  const [searchParams] = useSearchParams();

  const requestStatus = useRedeemEmailConfirmationToken(searchParams);

  return (
    <>
      {requestStatus === RequestStatus.Failed && (
        <p>{tr8('something-went-wrong')}</p>
      )}
      {requestStatus === RequestStatus.InvalidParams && (
        <p>{tr8('something-went-wrong')}</p>
      )}
      {requestStatus === RequestStatus.Pending && (
        <p>{tr8('Confirming your email')}</p>
      )}
      {requestStatus === RequestStatus.Succeeded && (
        <p>{tr8('successfully-confirmed-email')}</p>
      )}
    </>
  );
};
